
<script>
    export default {
        props: ['berita', 'textColor', 'meta']
    };
</script>
<template>
    <div class="row mb-5">
        <div class="col-lg-6 col-12">
            <div class="about-image-two">
                <img :src="berita.image" class="img-fluid" alt="blog-image">
            </div>
        </div>
        <div class="col-lg-6 col-12">
            <div class="about-content-two mb-3">
                <h5 class="text-muted mb-2">{{ berita.date }}</h5>
                <h4 class="font-size-15 mb-3">{{ berita.title }}</h4>
                <p>
                   {{berita.body.replace(/<\/?[^>]+(>|$)/g, "").substring(0,150)}}
                </p>
            </div>
            <div class="text-right">
                <router-link :to="`berita-detail${meta.preview}id=${berita.url}`" class="btn btn-orange btn-pill">
                    Lihat Selengkapnya
                </router-link>
            </div>
        </div>
    </div>
</template>